<template>
    <div style="display:initial">
        <!-- 各平台篩選按鈕 -->
        <template v-for="(item,index) in value">
            <tg-button
                v-if="showAllBtn || index < 5"
                :classes="['tg-icon-circle']"
                style="display:initial !important;"
                round
                icon="times"
                @click.native="cancelCheckBox(item)"
                :key="item"
                :disabled="value.length == 1"
            >
                {{ item }}
               
            </tg-button>
        </template>

        <!-- 摺疊/顯示開關 -->
        <template v-if="value.length > 5">
            <span @click="changeShowAllBtn()">
                <i :class="['tg-icon tg-icon-arrow',{mirrorRotateLevel:showAllBtn}]" ></i>
            </span>
        </template>
    </div>

</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
    components: {
        TgButton
    },
    props: {
        value: Array,
        merchantList:Array,
        useText:Boolean
    },
    data(){
        return {
            showAllBtn:false,
        }
    },
    methods: {
        cancelCheckBox(item){
            let merchant = this.value.filter(x => {
                return x != item;
            })
            
            if(merchant.length == 0){
                merchant[0] = item;
            }

            this.value = merchant;

            this.$nextTick(() => {
                this.$emit("on-change",this.value);
            });
        },
        changeShowAllBtn(){
            this.showAllBtn = !this.showAllBtn;
            return this.showAllBtn;
        }
    },
};
</script>